export enum CustomerSegment {
  Starter = 'starter',
  Switcher = 'switcher',
}
